import { StatementDataStateContext } from "@gerrieDev/Store/Data/Statements/StatementSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

export interface StatementDetailsBalanceStyles {
    container?: GridContainerProps;
    titleItem?: GridItemProps;
    balanceItem?: GridItemProps;
    title?: TypographyProps;
    balance?: TypographyProps;
}

export const statementBalanceStyles: StatementDetailsBalanceStyles = {
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: end;
        `
    },
    title: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            font-size: 16px;
        `,
    },
};

const styles = statementBalanceStyles;

const StatementDetailsBalance = () => {
    const statementsDataView = useContext(StatementDataStateContext);

    const statement = statementsDataView.value;

    if (!statement) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container} data-test-selector="statementDetail_balanceDue">
            <Typography {...styles.title}>
                {translate("Balance Due")}
            </Typography>
            <Typography {...styles.balance}>
                {statement.balanceDisplay}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: StatementDetailsBalance,
    definition: {
        group: "Basic",
        displayName: "Statement Details Balance Due",
    },
};

export default widgetModule;
